import React from 'react';
import PropTypes from 'prop-types';
import { FlexGrid } from '@gasbuddy/react-components';

import styles from './styles.css';

export default function CTAContainer({ children, alignment, className, ...rest }) {
  return (
    <FlexGrid container className={`${styles.ctaContainer} ${className} ${alignment === 'right' ? styles.rightAlign : ''}`}>
      <div {...rest}>
        {children}
      </div>
    </FlexGrid>
  );
}

CTAContainer.propTypes = {
  children: PropTypes.node.isRequired,
  alignment: PropTypes.string,
  className: PropTypes.string,
};

CTAContainer.defaultProps = {
  alignment: '',
  className: '',
};
